module.exports = __webpack_public_path__ + "bab5860b68ffb093ed86e4f5e34fa2e4.svg";


//////////////////
// WEBPACK FOOTER
// ../images/icons/svg/icon-gavel.svg
// module id = 2094
// module chunks = 69